
import React, { useState } from 'react';
import Cart from './Cart';
import ShowProduct from './ShowProduct';

export default function AllProductShow() {
  const [cart, setCart] = useState([]);

  // Add item to cart
  const handleAddToCart = (product) => {
    const existingIndex = cart.findIndex((item) => item.name === product.name);
    if (existingIndex !== -1) {
      const updatedCart = [...cart];
      updatedCart[existingIndex].quantity += 1;
      setCart(updatedCart);
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  };

  // Update quantity of a product
  const handleUpdateQuantity = (index, newQuantity) => {
    if (newQuantity < 1) return;
    const updatedCart = [...cart];
    updatedCart[index].quantity = newQuantity;
    setCart(updatedCart);
  };

  // Remove item from cart
  const handleRemoveItem = (index) => {
    const updatedCart = cart.filter((_, i) => i !== index);
    setCart(updatedCart);
  };

  return (
    <div style={{ padding: '20px' }}>
      <ShowProduct onAddToCart={handleAddToCart} />
      <Cart
        cartItems={cart}
        onUpdateQuantity={handleUpdateQuantity}
        onRemove={handleRemoveItem}
      />
    </div>
  );
}
